import Block, { BlockContent } from "~/components/Block";
import { GoogleFormsIFrame, GoogleFormsIFrameProps } from "~/components/GoogleForms";
import { getCommonSliceProps } from "~/external/prismic";
import { CommonSliceProps } from "~/external/prismic.types";
import connectSlice from "~/lib/connectSlice";

type GoogleFormsEmbedProps = GoogleFormsIFrameProps & CommonSliceProps;

function GoogleFormsEmbed(props: GoogleFormsEmbedProps) {
  const { spacingTop, spacingBottom, backgroundColor, color } = props;

  return (
    <Block
      spacingTop={spacingTop}
      spacingBottom={spacingBottom}
      backgroundColor={backgroundColor}
      color={color}
    >
      <BlockContent>
        <GoogleFormsIFrame {...props} />
      </BlockContent>
    </Block>
  );
}

function mapSliceToProps(slice: any): GoogleFormsEmbedProps {
  const { primary, items } = slice;

  const props = {
    ...getCommonSliceProps(slice),
    url: primary.url,
    height: primary.height ? primary.height : undefined,
  };

  return props;
}

export default connectSlice(mapSliceToProps)(GoogleFormsEmbed);
